import { makeStyles } from '@fluentui/react-components';

export const useLoginButtonStyles = makeStyles({
    userInfo: {
        padding: '4px 0',
    },
    displayName: {
        fontWeight: '600',
    },
    username: {
        fontSize: '12px',
        opacity: '0.8',
    },
});
